import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/org/$org/portfolio/')({
  beforeLoad: async ({ params }) => {
    throw redirect({
      to: '/org/$org/portfolio/table',
      params: { org: params.org },
    });
  },
});
